// Nine hair-system profiles for the "Catálogo de prótesis capilares" guide.
// Each entry keeps duration/priority text used for the comparison table plus a
// `heroImage` (served from /public/assets/catalogo-protesis) and the shop URL
// that already exists in the Arthur Fitz store.

export const hairSystems = [
  {
    slug: 'v-loop-ultrafina',
    name: 'V-Loop ultrafina',
    family: 'Poliuretano ultrafino',
    tagline: 'El máximo protagonismo para un acabado visual delicado.',
    summary:
      'Base V-Loop de 0,02–0,04 mm, concebida para quienes priorizan ligereza, discreción y un efecto visual muy integrado, con una duración media orientativa cercana a 2 meses.',
    base: 'Poliuretano V-Loop de 0,02–0,04 mm',
    duration: 'Aprox. 2 meses',
    density: 'Ligera a media',
    priority: 'Naturalidad y mínimo espesor',
    idealFor:
      'Personas que buscan una base especialmente fina y aceptan dedicar más atención al cuidado.',
    maintenance:
      'Manipulación suave y seguimiento profesional adaptado al adhesivo y al ritmo de uso.',
    heroImage: '/assets/catalogo-protesis/v-loop-ultrafina.premium.hero.webp',
    heroAlt:
      'Vista editorial premium de la base completa de una prótesis capilar V-Loop ultrafina de 0,02 a 0,04 mm.',
    productId: '5fe001c1-2b4d-4355-b88d-a6f023d5f238',
    gallery: [
      { src: '/assets/catalogo-protesis/v-loop-ultrafina.premium.hair.webp', caption: 'Coronilla, movimiento y mezcla natural de tonos', alt: 'Vista editorial del cabello y la coronilla de una prótesis V-Loop ultrafina.' },
      { src: '/assets/catalogo-protesis/v-loop-ultrafina.premium.parting.webp', caption: 'Raya e implantación V-Loop de perfil bajo', alt: 'Primer plano de la raya y la implantación V-Loop de perfil bajo.' },
      { src: '/assets/catalogo-protesis/v-loop-ultrafina.premium.front.webp', caption: 'Frontal ultrafino y salida individual del cabello', alt: 'Detalle del frontal ultrafino y la salida individual del cabello.' },
      { src: '/assets/catalogo-protesis/v-loop-ultrafina.premium.edge.webp', caption: 'Perfil flexible y mínimo espesor de la base', alt: 'Primer plano del perfil flexible de la base V-Loop.' },
      { src: '/assets/catalogo-protesis/v-loop-ultrafina.premium.texture.webp', caption: 'Textura, movimiento y reflejos naturales', alt: 'Detalle de la textura, el movimiento y la mezcla de canas.' },
    ],
    strengths: [
      ['Espesor mínimo', '0,02–0,04 mm para una presencia especialmente discreta.'],
      ['Acabado visual', 'La base está pensada para integrarse con delicadeza en el conjunto.'],
      ['Ligereza', 'Una opción orientada a quien prioriza una sensación poco voluminosa.'],
    ],
    consideration:
      'La referencia de 2 meses responde a la media observada en las ventas de los últimos años. Al tratarse de una base especialmente fina, la duración real puede variar por el trato, la frecuencia de uso, la exposición solar, el calor, el sudor, los adhesivos, los productos químicos y el mantenimiento.',
  },
  {
    slug: 'v-loop-fina',
    name: 'V-Loop fina',
    family: 'Poliuretano fino',
    tagline: 'Un equilibrio sereno entre naturalidad y vida útil.',
    summary:
      'Sistema V-Loop fino para quienes desean un acabado limpio y una duración orientativa de entre 3 y 4 meses.',
    base: 'Poliuretano fino con inserción V-Loop',
    duration: '3–4 meses',
    density: 'Ligera a media',
    priority: 'Equilibrio entre finura y uso',
    idealFor:
      'Personas que buscan naturalidad diaria con una vida útil mayor que la versión ultrafina.',
    maintenance:
      'Limpieza delicada, revisiones de adhesión y almacenamiento correcto cuando no se utiliza.',
    heroImage: '/assets/catalogo-protesis/product.gallery.underside.webp',
    heroAlt: 'Vista editorial de la parte interior de una prótesis capilar V-Loop.',
    productId: '6cf61544-0259-43c3-8409-49eba42b7dcf',
    gallery: [
      { src: '/assets/catalogo-protesis/product.gallery.underside.webp', caption: 'Vista interior y base', alt: 'Vista cercana de la parte interior y la base de la prótesis capilar V-Loop fina.' },
      { src: '/assets/catalogo-protesis/product.gallery.rooting.webp', caption: 'Integración del cabello en la base', alt: 'Primer plano de la integración del cabello en la base V-Loop.' },
      { src: '/assets/catalogo-protesis/product.gallery.parting.webp', caption: 'Raya, densidad y tonalidades', alt: 'Vista cercana de la raya, la densidad y las tonalidades del cabello.' },
      { src: '/assets/catalogo-protesis/product.gallery.edge.webp', caption: 'Borde y cabello', alt: 'Detalle del borde y del cabello de la prótesis capilar V-Loop.' },
      { src: '/assets/catalogo-protesis/product.gallery.texture.webp', caption: 'Textura y movimiento natural', alt: 'Detalle de la textura y el movimiento natural del cabello.' },
      { src: '/assets/catalogo-protesis/vloop.material-detail.webp', caption: 'Material V-Loop en detalle', alt: 'Primer plano del material V-Loop.' },
    ],
    strengths: [
      ['Perfil discreto', 'Una base fina para acompañar un contorno visualmente limpio.'],
      ['Uso cotidiano', 'Pensada para integrarse en una rutina de cuidado regular.'],
      ['Duración equilibrada', 'Entre 3 y 4 meses como referencia, dependiendo del mantenimiento.'],
    ],
    consideration:
      'La duración puede reducirse con calor, sudoración intensa, tirones, adhesivos inadecuados o limpiezas agresivas.',
  },
  {
    slug: 'malla-francesa',
    name: 'Malla francesa',
    family: 'Malla transpirable',
    tagline: 'Confort, ventilación y una construcción equilibrada.',
    summary:
      'Una base de malla con estructura algo más firme, adecuada para quienes valoran transpirabilidad y resistencia cotidiana.',
    base: 'Malla francesa',
    duration: 'Aprox. 4 meses',
    density: 'Media',
    priority: 'Transpirabilidad y equilibrio',
    idealFor: 'Personas activas o que prefieren una base ventilada con buena estabilidad.',
    maintenance: 'Desenredado cuidadoso y limpieza sin frotar ni ejercer tensión sobre la malla.',
    heroImage: '/assets/catalogo-protesis/malla-francesa.premium.hero.webp',
    heroAlt:
      'Presentación editorial premium de la vista interior de una prótesis capilar de malla francesa.',
    productId: 'd6cda2c2-9b35-4bc0-b2c7-4265b8fb0c99',
    gallery: [
      { src: '/assets/catalogo-protesis/malla-francesa.premium.base.webp', caption: 'Construcción interior y refuerzos', alt: 'Vista premium de la construcción interior y los refuerzos de una prótesis de malla francesa.' },
      { src: '/assets/catalogo-protesis/malla-francesa.premium.weave.webp', caption: 'Trama, nudos y transparencia', alt: 'Fotografía macro de la trama, los nudos y la implantación de la malla francesa.' },
      { src: '/assets/catalogo-protesis/malla-francesa.real.ventilation.webp', caption: 'Ventilación y dirección de implantación', alt: 'Vista editorial de la ventilación y la dirección de implantación sobre malla francesa.' },
      { src: '/assets/catalogo-protesis/malla-francesa.premium.hair.webp', caption: 'Textura y mezcla natural de tonos', alt: 'Presentación de la textura y la mezcla natural de tonos del cabello.' },
    ],
    strengths: [
      ['Ventilación', 'La estructura de malla favorece una experiencia más aireada.'],
      ['Versatilidad', 'Se adapta a diferentes estilos, densidades y rutinas.'],
      ['Resistencia equilibrada', 'Duración orientativa cercana a 4 meses con un cuidado adecuado.'],
    ],
    consideration:
      'La malla necesita una manipulación consciente: los tirones en la base o el cepillado desde la raíz pueden acortar su vida útil.',
  },
  {
    slug: 'malla-suiza',
    name: 'Malla suiza',
    family: 'Malla de máxima finura',
    tagline: 'Una elección ligera para quienes anteponen la sutileza.',
    summary:
      'Malla especialmente fina y discreta, orientada a un acabado delicado con una duración aproximada de 2 meses.',
    base: 'Malla suiza fina',
    duration: 'Aprox. 2 meses',
    density: 'Ligera',
    priority: 'Sutileza y transpirabilidad',
    idealFor:
      'Personas que priorizan una malla muy fina y comprenden que su delicadeza requiere mayor cuidado.',
    maintenance: 'Limpieza muy suave, mínima fricción y revisiones frecuentes de la fijación.',
    heroImage: '/assets/catalogo-protesis/malla-suiza.premium.hero.webp',
    heroAlt:
      'Presentación editorial premium de la vista interior de una prótesis capilar de malla suiza.',
    productId: 'c86d55da-1ec5-4c9c-b13a-1d764651c1fd',
    gallery: [
      { src: '/assets/catalogo-protesis/malla-suiza.premium.hair.webp', caption: 'Textura, movimiento y tonos naturales', alt: 'Vista premium de la textura, las ondas y los tonos naturales del cabello.' },
      { src: '/assets/catalogo-protesis/malla-suiza.premium.crown.webp', caption: 'Coronilla y distribución del cabello', alt: 'Vista superior de la coronilla y la distribución del cabello.' },
      { src: '/assets/catalogo-protesis/malla-suiza.premium.parting.webp', caption: 'Raya, implantación y flexibilidad de la base', alt: 'Primer plano de la raya y la implantación en la malla suiza.' },
      { src: '/assets/catalogo-protesis/malla-suiza.premium.front.webp', caption: 'Frontal fino y transición del cabello', alt: 'Detalle del borde frontal fino y la transición del cabello.' },
    ],
    strengths: [
      ['Malla delicada', 'Una construcción pensada para reducir su presencia visual.'],
      ['Sensación aireada', 'Favorece una experiencia ligera en el uso diario.'],
      ['Acabado refinado', 'Adecuada para densidades moderadas y estilos naturales.'],
    ],
    consideration:
      'Su mayor finura implica una vida útil más corta y exige especial atención al retirar adhesivos, lavar y peinar.',
  },
  {
    slug: 'skin-anudada',
    name: 'Skin anudada resistente',
    family: 'Skin anudada · 0,06 mm',
    tagline: 'Una base resistente para estilos con densidad y presencia.',
    summary:
      'Base skin de 0,06 mm con cabello anudado y densidad alta, concebida para ofrecer una sujeción firme, mayor cuerpo y una duración orientativa de 4 a 8 meses.',
    base: 'Skin de 0,06 mm con cabello anudado',
    duration: '4–8 meses',
    density: 'Alta',
    priority: 'Densidad y resistencia',
    idealFor:
      'Personas que desean una apariencia con mayor cuerpo, valoran una sujeción firme del cabello y priorizan una base resistente.',
    maintenance:
      'Hidratación regular del cabello, cepillado progresivo sin tirar desde la raíz y mantenimiento cuidadoso de la base y la adhesión.',
    heroImage: '/assets/catalogo-protesis/skin-anudada.premium.hero.webp',
    heroAlt:
      'Vista editorial premium de la base skin de 0,06 mm y los puntos de anudado de una prótesis capilar resistente.',
    productId: '1e69c050-fcd4-45a6-9066-cbce7cd7d8b1',
    gallery: [
      { src: '/assets/catalogo-protesis/skin-anudada.premium.hair.webp', caption: 'Volumen, ondas y mezcla natural de tonos', alt: 'Vista editorial del volumen, las ondas y los tonos naturales.' },
      { src: '/assets/catalogo-protesis/skin-anudada.premium.edge.webp', caption: 'Borde, flexibilidad y nacimiento', alt: 'Primer plano del borde flexible y el nacimiento del cabello.' },
      { src: '/assets/catalogo-protesis/skin-anudada.premium.knots.webp', caption: 'Puntos de anudado y densidad', alt: 'Detalle macro de los nudos y la densidad del cabello.' },
      { src: '/assets/catalogo-protesis/skin-anudada.premium.parting.webp', caption: 'Raya, nudos y mezcla de canas', alt: 'Primer plano de la raya, los nudos y la mezcla de canas.' },
      { src: '/assets/catalogo-protesis/skin-anudada.premium.texture.webp', caption: 'Textura, dirección y reflejos naturales', alt: 'Detalle de la textura, la dirección y los tonos.' },
    ],
    strengths: [
      ['Skin de 0,06 mm', 'Una base con mayor cuerpo, pensada para ofrecer resistencia en el uso y el mantenimiento.'],
      ['Anudado firme', 'Los puntos de anudado favorecen una sujeción sólida del cabello sobre la base.'],
      ['Densidad alta', 'Permite construir estilos con volumen y una presencia capilar más marcada.'],
    ],
    consideration:
      'El anudado y la densidad alta aportan más cuerpo que una prótesis inyectada o una base ultrafina. Puede no ser la elección ideal para quien busca un acabado especialmente plano o ligero.',
  },
  {
    slug: 'inyectada',
    name: 'Prótesis inyectada',
    family: 'Skin con implantación individual',
    tagline: 'Un nacimiento preciso para una caída baja y especialmente natural.',
    summary:
      'Modelo skin en el que el cabello nace de forma individual y queda orientado tumbado sobre la base, reduciendo el volumen desde la raíz y favoreciendo una integración visual muy natural, con una duración media orientativa de 4 a 6 meses.',
    base: 'Skin con cabello inyectado individualmente',
    duration: '4–6 meses',
    density: 'Ligera a media · perfil bajo',
    priority: 'Naturalidad y poco volumen',
    idealFor:
      'Personas que buscan una caída próxima a la base, con poco volumen desde la raíz y un acabado discreto.',
    maintenance:
      'Cepillado suave siguiendo la dirección del cabello, limpieza delicada de la base y manipulación sin tirar desde la raíz.',
    heroImage: '/assets/catalogo-protesis/inyectado.premium.hero.webp',
    heroAlt:
      'Vista editorial premium de la base skin y la implantación individual de una prótesis capilar inyectada.',
    productId: '8ed53b31-0200-4130-a091-4b51024edc22',
    gallery: [
      { src: '/assets/catalogo-protesis/inyectado.premium.hair.webp', caption: 'Acabado exterior y caída de perfil bajo', alt: 'Vista editorial del acabado exterior, las ondas y la caída de perfil bajo.' },
      { src: '/assets/catalogo-protesis/inyectado.premium.front.webp', caption: 'Frontal, transparencia y dirección del cabello', alt: 'Primer plano del frontal y la salida tumbada del cabello.' },
      { src: '/assets/catalogo-protesis/inyectado.premium.injection.webp', caption: 'Cabellos implantados de forma individual', alt: 'Detalle macro de la implantación individual del cabello.' },
      { src: '/assets/catalogo-protesis/inyectado.premium.parting.webp', caption: 'Raya y nacimiento próximo a la base', alt: 'Primer plano de la raya y el nacimiento individual del cabello.' },
      { src: '/assets/catalogo-protesis/inyectado.premium.direction.webp', caption: 'Dirección tumbada y caída natural', alt: 'Detalle de la dirección tumbada y la caída natural del cabello.' },
    ],
    strengths: [
      ['Implantación individual', 'Cada cabello nace de forma independiente para ofrecer una distribución visualmente precisa.'],
      ['Caída tumbada', 'La orientación próxima a la base evita un volumen marcado desde la raíz.'],
      ['Acabado natural', 'Favorece estilos bajos, fluidos y especialmente discretos.'],
    ],
    consideration:
      'No es el modelo más indicado para peinar el frontal completamente levantado. La duración de 4 a 6 meses es una media histórica orientativa y puede cambiar según el trato, el uso, la exposición solar, los productos químicos, la adhesión y el mantenimiento.',
  },
  {
    slug: 'mixta',
    name: 'Prótesis mixta',
    family: 'Frontal de malla + skin 0,06 mm',
    tagline: 'Naturalidad frontal y una base estable en una misma construcción.',
    summary:
      'Sistema mixto con frontal de malla y resto de base skin de 0,06 mm, concebido para combinar una transición frontal delicada, fijación definida y una duración media orientativa de 4 a 8 meses.',
    base: 'Frontal de malla y resto skin de 0,06 mm',
    duration: '4–8 meses',
    density: 'Media y adaptable',
    priority: 'Naturalidad frontal y estabilidad',
    idealFor:
      'Personas que buscan la delicadeza visual de un frontal de malla y una superficie skin definida en el resto de la base.',
    maintenance:
      'Manipulación suave del frontal de malla, limpieza cuidada del skin y revisiones periódicas para conservar la unión y la fijación.',
    heroImage: '/assets/catalogo-protesis/mixta.premium.hero.webp',
    heroAlt:
      'Vista editorial premium de la construcción interior de una prótesis mixta con frontal de malla y base skin de 0,06 mm.',
    productId: 'f2df6980-d250-45f2-a56a-edef43d389e3',
    gallery: [
      { src: '/assets/catalogo-protesis/mixta.premium.parting.webp', caption: 'Raya, implantación y mezcla natural de canas', alt: 'Primer plano de la raya, la implantación y las canas.' },
      { src: '/assets/catalogo-protesis/mixta.premium.hair.webp', caption: 'Ondas, volumen y acabado exterior', alt: 'Vista editorial de las ondas, el volumen y la mezcla natural de canas.' },
      { src: '/assets/catalogo-protesis/mixta.premium.transition.webp', caption: 'Implantación y transición de la construcción', alt: 'Detalle de la transición de materiales en una prótesis mixta.' },
      { src: '/assets/catalogo-protesis/mixta.premium.crown.webp', caption: 'Coronilla y distribución del cabello', alt: 'Vista editorial de la coronilla, las ondas y la distribución de canas.' },
      { src: '/assets/catalogo-protesis/mixta.premium.texture.webp', caption: 'Textura, movimiento y ondas naturales', alt: 'Vista lateral de la textura, el movimiento y las ondas.' },
    ],
    strengths: [
      ['Frontal de malla', 'Favorece una transición visual delicada en la zona frontal.'],
      ['Skin de 0,06 mm', 'El resto de la base ofrece una superficie fina y definida para la fijación.'],
      ['Duración prolongada', 'Entre 4 y 8 meses como media orientativa, dependiendo del uso y el mantenimiento.'],
    ],
    consideration:
      'La malla y el skin requieren cuidados diferentes. La referencia de 4 a 8 meses responde a medias históricas de venta; la duración real depende del trato, la manipulación del frontal, la retirada del adhesivo, el uso, el sol, los productos químicos y el mantenimiento.',
  },
  {
    slug: 'mixta-ventilaciones',
    name: 'Mixta con ventilaciones',
    family: 'Base mixta · paneles ventilados',
    tagline: 'Ventilación por zonas y soporte en una construcción versátil.',
    summary:
      'Construcción mixta que combina un panel central fino, zonas de malla abierta y áreas de soporte, pensada para equilibrar ventilación, estabilidad y una densidad visual media, con una duración media orientativa de 4 a 8 meses.',
    base: 'Panel central fino, malla abierta y zonas de soporte',
    duration: '4–8 meses',
    density: 'Media',
    priority: 'Ventilación por zonas y estabilidad',
    idealFor:
      'Personas que valoran una base con áreas abiertas para favorecer una sensación más aireada sin renunciar a zonas de soporte y transición.',
    maintenance:
      'Limpieza delicada, mínima fricción sobre las mallas abiertas y manipulación cuidadosa de las uniones entre los distintos paneles.',
    heroImage: '/assets/catalogo-protesis/mixta-ventilaciones.premium.hero.webp',
    heroAlt:
      'Vista editorial premium de la construcción interior completa de una prótesis capilar mixta con zonas de ventilación.',
    productId: 'b64b3115-af70-4433-8490-376cf2767808',
    gallery: [
      { src: '/assets/catalogo-protesis/mixta-ventilaciones.premium.structure.webp', caption: 'Paneles, transiciones y distribución de la base', alt: 'Vista de los paneles, transiciones y zonas ventiladas.' },
      { src: '/assets/catalogo-protesis/mixta-ventilaciones.premium.ventilation.webp', caption: 'Malla abierta y ventilación localizada', alt: 'Detalle técnico de la malla abierta y las zonas de ventilación.' },
      { src: '/assets/catalogo-protesis/mixta-ventilaciones.premium.front.webp', caption: 'Frontal de malla e implantación', alt: 'Primer plano del frontal de malla y la implantación del cabello.' },
      { src: '/assets/catalogo-protesis/mixta-ventilaciones.premium.edge.webp', caption: 'Borde, nacimiento y transición de materiales', alt: 'Detalle del borde y la transición de materiales.' },
      { src: '/assets/catalogo-protesis/mixta-ventilaciones.premium.parting.webp', caption: 'Raya, implantación y malla ventilada', alt: 'Detalle de la raya, la implantación y la malla ventilada.' },
      { src: '/assets/catalogo-protesis/mixta-ventilaciones.premium.hair.webp', caption: 'Ondas, volumen y mezcla natural de canas', alt: 'Vista de las ondas, el volumen y la mezcla de canas.' },
    ],
    strengths: [
      ['Ventilación localizada', 'Las zonas de malla abierta reducen la superficie cubierta y aportan una construcción visualmente más aireada.'],
      ['Construcción mixta', 'Combina paneles de distinta apertura y áreas de soporte dentro de una misma base.'],
      ['Equilibrio de uso', 'Busca reunir ventilación, estabilidad y una densidad media adaptable a diferentes estilos.'],
    ],
    consideration:
      'Las mallas abiertas y las zonas de transición necesitan una manipulación especialmente cuidadosa. La referencia de 4 a 8 meses procede de las medias observadas en las ventas de los últimos años y puede variar por el trato, el uso, la exposición solar, los productos químicos, la adhesión y la retirada.',
  },
  {
    slug: 'mixta-francesa-contorno-skin',
    name: 'Mixta francesa · contorno skin 0,06',
    family: 'Malla francesa + skin 0,06 mm',
    tagline: 'Ventilación amplia, confort y un contorno definido en una sola pieza.',
    summary:
      'Sistema mixto con frontal y zona central de malla francesa, rodeados por un contorno completo skin de 0,06 mm. Combina ventilación total, comodidad elevada y un acabado frontal de aspecto prácticamente invisible, con una duración media orientativa de 4 a 8 meses. Disponible de inmediato en la mayoría de los casos, sujeto a existencias.',
    base: 'Frontal y centro de malla francesa + contorno skin de 0,06 mm',
    duration: '4–8 meses',
    density: 'Media-alta',
    priority: 'Ventilación total y contorno estable',
    idealFor:
      'Personas que buscan una base ampliamente ventilada, un frontal de aspecto discreto y un contorno completo skin para facilitar una fijación perimetral definida.',
    maintenance:
      'Limpieza delicada de la malla, retirada cuidadosa del adhesivo en el contorno skin y mínima tensión sobre las transiciones entre materiales.',
    heroImage: '/assets/catalogo-protesis/mixta-francesa-skin.authentic.hero.webp',
    heroAlt:
      'Fotografía real del acabado exterior ondulado de la prótesis mixta francesa con contorno skin de 0,06 mm.',
    productId: 'bdf6a419-7cc4-418a-93d7-d748839ddf87',
    gallery: [
      { src: '/assets/catalogo-protesis/mixta-francesa-skin.authentic.base.webp', caption: 'Construcción interior y transición de la base', alt: 'Fotografía real de la construcción interior y las transiciones.' },
      { src: '/assets/catalogo-protesis/mixta-francesa-skin.authentic.front.webp', caption: 'Frontal y nacimiento del cabello', alt: 'Fotografía real del frontal y el nacimiento del cabello.' },
      { src: '/assets/catalogo-protesis/mixta-francesa-skin.authentic.perimeter.webp', caption: 'Contorno skin de 0,06 mm y malla interior', alt: 'Fotografía real del contorno skin de 0,06 mm y la malla interior.' },
      { src: '/assets/catalogo-protesis/mixta-francesa-skin.authentic.parting.webp', caption: 'Raya, implantación y mezcla natural de canas', alt: 'Fotografía real de la raya, la implantación y las canas.' },
      { src: '/assets/catalogo-protesis/mixta-francesa-skin.authentic.hair.webp', caption: 'Peinado, ondas y color real de la unidad', alt: 'Fotografía real del peinado, las ondas y el color.' },
    ],
    strengths: [
      ['Frontal de malla francesa', 'Una construcción fina y transpirable orientada a conseguir una transición frontal natural y discreta.'],
      ['Ventilación central', 'La zona principal de malla francesa favorece una sensación aireada y una comodidad elevada durante el uso.'],
      ['Contorno skin de 0,06 mm', 'El perímetro completo aporta una superficie continua y definida para trabajar la fijación.'],
    ],
    consideration:
      'La referencia de 4 a 8 meses es una media obtenida de las ventas de los últimos años, no una garantía. El resultado depende del trato, el uso, la exposición solar, los productos químicos, la adhesión, el mantenimiento y la retirada. Suele estar disponible para entrega inmediata, sujeto a existencias.',
  },
];

export function getHairSystem(slug) {
  return hairSystems.find((item) => item.slug === slug);
}
